import * as _ from 'lodash';
import { isGettextExpression, parseGettextExpression } from './parser';
import { GettextKind } from './types';

function esc(value: any) {
  if (_.isString(value)) {
    return value.replace(/\'/g, "\\'");
  }
  return value;
}

export function transformToFilterExpression(input: string): string {
  if (!isGettextExpression(input)) {
    throw new TypeError(`Not a valid gettext expression: ${input}`);
  }

  const parsed = parseGettextExpression(input);

  switch (parsed.kind) {
    case GettextKind.gettext:
      return `gettext('${esc(parsed.msgid)}')`;

    case GettextKind.pgettext:
      return `pgettext('${esc(parsed.context)}', '${esc(parsed.msgid)}')`;

    case GettextKind.ngettext:
      return `ngettext('${esc(parsed.msgid)}', '${esc(parsed.plural)}', ${parsed.n})`;

    case GettextKind.npgettext:
      return `npgettext('${esc(parsed.context)}', '${esc(parsed.msgid)}', '${esc(parsed.plural)}', ${parsed.n})`;

    default:
      return input;
  }
}

/**
 * Removes accents from string.
 */
export function unaccent(value: string) {
  if (_.isString(value)) {
    return value.normalize('NFD').replace(/\p{Diacritic}/gu, '');
  }
  return value;
}
